( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'fifty-fifty-split-left-right', COMPONENT );
} )( app );
